import React from 'react';
import { IndexRoute, Route } from 'react-router';

import { hasAccess, hasAffiliateAccess, hasInternalAccess, hasRestrictedModuleAccess } from '../utils/auth';

import Accounting from '../containers/Accounting';
import AccountingIFCA from '../containers/AccountingIFCA';
import AccountingInsoft from '../containers/AccountingInsoft';
import Activities from '../containers/Activities';
import AddressSettingActivities from '../containers/SystemSettings/AddressSettingActivities';
import AffiliateMappings from '../containers/AffiliateMappings';
import AppLoading from '../containers/AppLoading';
import BookApp from '../containers/BookApp';
import BookDash from '../containers/BookDash';
import Bookings from '../containers/Bookings';
import BusinessUnits from '../containers/BusinessUnits';
import CancellationReasons from '../containers/CancellationReasons';
import CompanyCurrencies from '../containers/CompanyCurrencies';
import CompanyDocuments from '../containers/CompanyDocuments';
import Customers from '../containers/Customers';
import CustomOptions from '../containers/CustomOptions';
import Document from '../containers/Document';
import Documents from '../containers/Documents';
import Forbidden from '../containers/Forbidden';
import Integrations from '../containers/Integrations';
import Logo from '../containers/Logo';
import Logos from '../containers/Logos';
import Media from '../containers/Media';
import MultiEdit from '../containers/Project/MultiUnits/';
import NewProject from '../containers/Projects/New';
import NotFound from '../containers/NotFound';
import Payments from '../containers/Payments';
import Picture from '../containers/Picture';
import Pictures from '../containers/Pictures';
import PreferredBankers from '../containers/PreferredBankers';
import PriceNaming from '../containers/PriceNaming';
import Profile from '../containers/Profile';
import Project from '../containers/Project';
import ProjectList from '../containers/Projects/List';
import ProjectMappings from '../containers/ProjectMappings';
import Projects from '../containers/Projects';
import ProjectSpecifications from '../containers/ProjectSpecifications';
import ProjectUnit from '../containers/Project/Unit/Unit';
import ProjectUnitActivities from '../containers/Project/Unit/Activities';
import ProjectUnitEdit from '../containers/Project/Unit/Edit';
import ProjectUnitLayoutSpecifications from '../containers/ProjectUnitLayoutSpecifications';
import ProjectUnitOverview from '../containers/Project/Unit/Overview';
import ProjectUnitSpecifications from '../containers/ProjectUnitSpecifications';
import Reports from '../containers/Reports';
import Settings from '../containers/Settings';
import SMSTemplates from '../containers/SMSTemplates';
import Staffs from '../containers/Staffs';
import SystemSettings from '../containers/SystemSettings';
import Tags from '../containers/Tags';
import Templates from '../containers/Templates';
import Video from '../containers/Video';
import Videos from '../containers/Videos';
import { NEW_PROJECT_PROMPT } from '../constants/promptMessages';
import { checkChanges } from '../utils/checkChanges';
import Opportunities from '../containers/Opportunities/Opportunities';

export default (
  <Route>
    <Route path="/loading/" component={AppLoading} />
    <Route path="/forbidden/" component={Forbidden} />
    <Route path="/" component={hasAccess(BookApp)}>
      <IndexRoute component={BookDash} />
      <Route path="accounting/" component={Accounting}>
        <IndexRoute component={Accounting} />
      </Route>
      <Route path="accounting_ifca/" component={AccountingIFCA}>
        <IndexRoute component={AccountingIFCA} />
      </Route>
      <Route path="accounting_insoft/" component={AccountingInsoft}>
        <IndexRoute component={AccountingInsoft} />
      </Route>
      <Route path="activities/" component={Activities}>
        <IndexRoute component={Activities.Overview} />
        <Route path="bookings/" component={Activities.Overview} />
        <Route path="project_units/" component={Activities.Overview} />
        <Route path="projects/" component={Activities.Overview} />
        <Route path="exports/" component={Activities.Overview} />
        <Route path="users/" component={Activities.Overview} />
        <Route path="business_units/" component={Activities.Overview} />
      </Route>
      <Route path="bookings/" component={Bookings}>
        <IndexRoute component={Bookings.List} />
        <Route path="unit_progress/" component={Bookings.UnitProgress} />
        <Route path="manage/" component={Bookings.ManageBookings} />
        <Route path="new/" component={Bookings.New} />
        <Route path="hims/" component={Bookings.HIMSBookingSync} />
        <Route path="customEdit/" component={Bookings.CustomEdit} />
      </Route>
      <Route path="bookings/:id/" component={Bookings}>
        <IndexRoute component={Bookings.Overview} />
        <Route path="activities/" component={Bookings.Activities} />
        <Route path="loan/" component={Bookings.Loan} />
        <Route path="payment/" component={Bookings.Payment} />
        <Route path="lppsa/" component={Bookings.LPPSA} />
        <Route path="credit_check/" component={Bookings.CreditCheck} />
        <Route path="customers/:customerID/credit_check/" component={Customers.CreditCheck} />
      </Route>
      {/* new opportunity for vietnam */}
      <Route path="opportunities/" component={hasInternalAccess(Opportunities)}>
        <IndexRoute component={Opportunities.List} />
        <Route path="manage_refunds/" component={Opportunities.ManageRefunds} />
        <Route path="exports/" component={Opportunities.Exports} />
      </Route>
      <Route path="opportunities/:id/" component={hasInternalAccess(Opportunities)}>
        <IndexRoute component={Opportunities.Overview} />
      </Route>
      <Route path="business_units/" component={BusinessUnits} >
        <IndexRoute component={BusinessUnits.List} />
        <Route path="new/" component={BusinessUnits.New} />
        <Route path=":id/" component={BusinessUnits.Overview} />
        <Route path=":id/activities/" component={BusinessUnits.Activities} />
      </Route>
      <Route path="customers/manage/credit_checks/" component={Customers.ManageCreditCheck} />
      <Route path="customers/manage/credit_checks/settings/" component={Customers.ManageCreditCheckSettings} />
      <Route path="customers/" component={Customers}>
        <IndexRoute component={Customers.List} />
        <Route path="new/" component={Customers.New} />
      </Route>
      <Route path="bookings/:id/customers/:customerID/income/:incomeID/" component={Customers.NewEditIncome} />
      <Route path="customers/:id/income/:incomeID/" component={Customers.NewEditIncome} />
      <Route path="customers/:id/" component={Customers}>
        <IndexRoute component={Customers.Overview} />
        <Route path="details/:detailID/" component={Customers.Edit} />
        <Route path="credit_check/" component={Customers.CreditCheck} />
        <Route path="credit_checks/:creditCheckID/multiple_entities/" component={Customers.MultipleEntity} />
      </Route>
      <Route path="integrations/" component={Integrations}>
        <Route path="sf/" component={Integrations.Salesforce} />
      </Route>
      <Route path="media/" component={Media}>
        <IndexRoute component={Media.Dash} />
      </Route>
      <Route path="media/documents/" component={Documents}>
        <IndexRoute component={Documents.List} />
      </Route>
      <Route path="media/documents/:id/" component={Document}>
        <IndexRoute component={Document.Edit} />
      </Route>
      <Route path="media/logos/" component={Logos}>
        <IndexRoute component={Logos.List} />
      </Route>
      <Route path="media/logos/:id/" component={Logo}>
        <IndexRoute component={Logo.Edit} />
      </Route>
      <Route path="media/pictures/" component={Pictures}>
        <IndexRoute component={Pictures.List} />
      </Route>
      <Route path="media/pictures/:id/" component={Picture}>
        <IndexRoute component={Picture.Edit} />
      </Route>
      <Route path="media/videos/" component={Videos}>
        <IndexRoute component={Videos.List} />
      </Route>
      <Route path="media/videos/:id/" component={Video}>
        <IndexRoute component={Video.Edit} />
      </Route>
      <Route path="payments/" component={hasRestrictedModuleAccess(Payments)} />
      <Route path="projects/" component={Projects}>
        <IndexRoute component={ProjectList} />
        <Route path="new/" component={checkChanges(NewProject, { message: NEW_PROJECT_PROMPT })} />
      </Route>
      <Route path="projects/:id/" component={Project}>
        <IndexRoute component={Project.Overview} />
        <Route path="lawyers/" component={Project.PanelLawyers} />
        <Route path="bankers/" component={Project.PanelBankers} />
        <Route path="documents/" component={Project.Documents} />
        <Route path="logo/" component={Project.Logo} />
        <Route path="edit/" component={Project.Edit} />
        <Route path="package_pricings/" component={Project.PackagePricing} />
        <Route path="pictures/" component={Project.Pictures} />
        <Route path="videos/" component={Project.Videos} />
        <Route path="layouts/" component={Project.UnitLayouts}>
          <IndexRoute component={Project.UnitLayouts.List} />
          <Route path="new/" component={Project.UnitLayouts.New} />
          <Route path="compare/" component={Project.UnitLayouts.Compare} />
        </Route>
        <Route path="layouts/:unitLayoutID/" component={Project.UnitLayout}>
          <IndexRoute component={Project.UnitLayout.Overview} />
          <Route path="edit/" component={Project.UnitLayout.Edit} />
          <Route path="pictures/" component={Project.UnitLayout.Pictures} />
          <Route path="documents/" component={Project.UnitLayout.Documents} />
          <Route path="videos/" component={Project.UnitLayout.Videos} />
        </Route>
        <Route path="units/" component={Project.Units}>
          <IndexRoute component={Project.Units.List} />
          <Route path="create/" component={Project.Units.New} />
          <Route path="import/" component={Project.Units.Import} />
          <Route path="import_pricings/" component={Project.Units.ImportPricing} />
          <Route path="edit/" component={hasAffiliateAccess(MultiEdit.Edit)} />
          <Route path="compare/" component={Project.Units.UnitsCompare} />
          <Route path="hims/" component={Project.Units.HIMSUnitSync}>
            <IndexRoute component={Project.Units.HIMSUnitSync} />
            <Route path=":himsSettingID/" component={Project.Units.HIMSUnitSync} />
            <Route path=":himsSettingID/components/" component={Project.Units.HIMSUnitSync} />
            <Route path=":himsSettingID/components/:componentID/" component={Project.Units.HIMSUnitSync} />
          </Route>
        </Route>
        <Route path="units/:unitID/" component={ProjectUnit}>
          <IndexRoute component={checkChanges(ProjectUnitOverview)} />
          <Route path="edit/" component={checkChanges(ProjectUnitEdit)} />
          <Route path="activities/" component={ProjectUnitActivities} />
        </Route>
        <Route path="reports/" component={Project.Reports} />
        <Route path="activities/" component={Project.Activities} />
      </Route>
      <Route path="preferred_bankers/" component={hasRestrictedModuleAccess(PreferredBankers)}>
        <IndexRoute component={PreferredBankers.List} />
      </Route>
      <Route path="reports/" component={hasRestrictedModuleAccess(Reports)} >
        <IndexRoute component={Reports.Overview} />
      </Route>
      <Route path="settings/" component={Settings}>
        <IndexRoute component={Settings.Dash} />
      </Route>
      <Route path="settings/company_documents/" component={CompanyDocuments}>
        <IndexRoute component={CompanyDocuments.List} />
      </Route>
      <Route path="settings/custom_options/" component={CustomOptions} />
      <Route path="settings/system_settings/" component={SystemSettings} />
      <Route path="settings/address_settings/activities/" component={AddressSettingActivities} />
      <Route path="settings/price_naming/" component={PriceNaming} />
      <Route path="settings/projects/" component={ProjectSpecifications}>
        <IndexRoute component={ProjectSpecifications.List} />
        <Route path="new/" component={ProjectSpecifications.New} />
        <Route path=":projectSpecificationID/" component={ProjectSpecifications.Edit} />
      </Route>
      <Route path="settings/mappings/projects/" component={ProjectMappings}>
        <IndexRoute component={ProjectMappings.List} />
        <Route path="new/" component={ProjectMappings.New} />
        <Route path=":projectMappingID/" component={ProjectMappings.Edit} />
      </Route>
      <Route path="settings/layouts/" component={ProjectUnitLayoutSpecifications}>
        <IndexRoute component={ProjectUnitLayoutSpecifications.List} />
        <Route path="new/" component={ProjectUnitLayoutSpecifications.New} />
        <Route path=":projectUnitLayoutSpecificationID/" component={ProjectUnitLayoutSpecifications.Edit} />
      </Route>
      <Route path="settings/units/" component={ProjectUnitSpecifications}>
        <IndexRoute component={ProjectUnitSpecifications.List} />
        <Route path="new/" component={ProjectUnitSpecifications.New} />
        <Route path=":projectUnitSpecificationID/" component={ProjectUnitSpecifications.Edit} />
      </Route>
      <Route path="settings/tags/" component={Tags}>
        <IndexRoute component={Tags.List} />
        <Route path="new/" component={Tags.New} />
        <Route path=":tagID/" component={Tags.Edit} />
      </Route>
      <Route path="settings/print_templates/" component={Templates}>
        <IndexRoute component={Templates.List} />
        <Route path="new/" component={Templates.New} />
        <Route path=":templateID/" component={Templates.Edit} />
      </Route>
      <Route path="settings/quotation_templates/" component={Templates}>
        <IndexRoute component={Templates.List} />
        <Route path="new/" component={Templates.New} />
        <Route path=":templateID/" component={Templates.Edit} />
      </Route>
      <Route path="settings/sms_templates/" component={SMSTemplates}>
        <IndexRoute component={SMSTemplates.List} />
        <Route path="new/" component={SMSTemplates.New} />
        <Route path=":smsTemplateID/" component={SMSTemplates.Edit} />
      </Route>
      <Route path="settings/currencies/" component={CompanyCurrencies} />
      <Route path="settings/mappings/affiliates/" component={AffiliateMappings}>
        <IndexRoute component={AffiliateMappings.List} />
        <Route path="new/" component={AffiliateMappings.New} />
        <Route path=":affiliateMappingID/" component={AffiliateMappings.Edit} />
      </Route>
      <Route path="settings/cancellation_reasons/" component={CancellationReasons}>
        <IndexRoute component={CancellationReasons.List} />
        <Route path="new/" component={CancellationReasons.New} />
        <Route path=":cancellationReasonID/" component={CancellationReasons.Edit} />
      </Route>
      <Route path="staff/" component={Staffs} >
        <IndexRoute component={Staffs.List} />
        <Route path="new/" component={Staffs.New} />
        <Route path=":id/" component={Staffs.Overview} />
        <Route path=":id/activities/" component={Staffs.Activities} />
      </Route>
      <Route path="users/" component={Staffs} >
        <IndexRoute component={Staffs.List} />
        <Route path="import/" component={Staffs.Import} />
        <Route path="new/" component={Staffs.New} />
        <Route path=":id/" component={Staffs.Overview} />
        <Route path=":id/activities/" component={Staffs.Activities} />
      </Route>
      <Route path="profile/" component={Profile} >
        <IndexRoute component={Profile.Overview} />
      </Route>
      <Route path="*" component={NotFound} />
    </Route>
  </Route>
);



// WEBPACK FOOTER //
// ./src/routes/book.jsx